export const INDUSTRY_TYPES = [
  { id: 1, code: 'AGG', name: 'Aggregator' },
  { id: 2, code: 'AGR', name: 'Agritech' },
  { id: 3, code: 'CM', name: 'Contract Manufacturer' },
  { id: 4, code: 'D2C', name: 'D2C' },
  { id: 5, code: 'ECOM', name: 'E-Commerce' },
  { id: 6, code: 'ELC', name: 'Electronics' },
  { id: 7, code: 'FMCG', name: 'FMCG' },
  { id: 8, code: 'FB', name: 'Food & Beverage' },
  { id: 9, code: 'HL', name: 'Home & Lifestyle' },
  { id: 10, code: 'LSC', name: 'Logistics & Supply Chain' },
  { id: 11, code: 'MF', name: 'Manufacturing' },
  { id: 12, code: 'QCOM', name: 'Quck-Com' },
  { id: 13, code: 'RET', name: 'Retail' },
  { id: 14, code: 'SCP', name: 'Scrap' },
  { id: 15, code: 'SOL', name: 'Solar' },
  { id: 16, code: 'TLC', name: 'Telecommunications' },
  { id: 17, code: 'TA', name: 'Textiles & Apparel' },
  { id: 18, code: 'WARE', name: 'Warehousing' },
];
